if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    connectedCallback() {
      this.bindForm();
    }

    disconnectedCallback() {
      if (this.form && this.onSubmit) {
        this.form.removeEventListener('submit', this.onSubmit);
      }
      if (this.atcButton && this.onAtcClick) {
        this.atcButton.removeEventListener('click', this.onAtcClick);
      }
      this._formBound = false;
    }

    bindForm() {
      if (this._formBound) return;

      this.form = this.querySelector('form[data-type="add-to-cart-form"]') || this.querySelector('form');
      if (!this.form) return;

      this._formBound = true;
      this.submitButton = this.querySelector('[data-pdp-atc], [type="submit"], [name="add"]');
      this.atcButton = this.submitButton;

      const variantInput = this.form.querySelector('[name="id"]');
      if (variantInput) variantInput.disabled = false;

      this.onSubmit = (evt) => this.onSubmitHandler(evt);
      this.form.addEventListener('submit', this.onSubmit);

      if (this.atcButton) {
        this.onAtcClick = (evt) => {
          evt.preventDefault();
          if (this.isSubmitting || this.atcButton.disabled) return;
          this.onSubmitHandler(evt);
        };
        this.atcButton.addEventListener('click', this.onAtcClick);
      }
    }

    setSubmitting(button, isSubmitting) {
      this.isSubmitting = isSubmitting;
      if (!button) return;

      button.classList.toggle('loading', isSubmitting);
      button.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');

      if (isSubmitting) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        return;
      }

      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.isSubmitting) return;

      const submitButton = evt.submitter || this.atcButton || this.submitButton;
      if (!submitButton) return;
      if (submitButton.disabled || submitButton.hasAttribute('disabled')) return;

      const variantInput = this.form.querySelector('[name="id"]');
      if (variantInput) variantInput.disabled = false;

      this.handleErrorMessage();
      this.error = false;
      this.setSubmitting(submitButton, true);

      const variantId = variantInput?.value;
      const quantity = parseInt(this.form.querySelector('[name="quantity"]')?.value || '1', 10);

      fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity }],
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }

          if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
          if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.setSubmitting(submitButton, false);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function initProductForms() {
  document.querySelectorAll('product-form').forEach((el) => el.bindForm?.());
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductForms);
} else {
  initProductForms();
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('product-form').forEach((el) => el.bindForm?.());
});
